import { lazy } from 'react';

// project-imports
import DashboardLayout from 'layout/Dashboard';
import Loadable from 'components/Loadable';
import { Navigate } from 'react-router-dom';
import AuthGuard from '../layout/Auth/AuthGuard';

// render - basic component pages
const Coupons = Loadable(lazy(() => import('../sections/coupons/Coupons')));

// ==============================|| COMPONENT ROUTING ||============================== //

const CouponCodeRoutes = {
  path: '/',
  element: <AuthGuard allowedRoles={['SUPER_ADMIN']}/>,
  children: [
    {
      path: '/',
      element: <DashboardLayout />,
      children: [
        {
          path: 'coupons',
          children: [
            {
              // This makes /menu automatically open /menu/categories
              index: true, 
              element: <Navigate to="/coupon-codes" replace /> 
            },
            {
              path: 'view-coupon-codes',
              element: <Coupons />
            }
          ]
        }
      ]
    }
  ]
};

export default CouponCodeRoutes;
